import React, { useEffect } from "react";
import AppProviders from "./components/Providers/AppProviders";
import AppLayout from "./components/Layout/AppLayout";
import "./App.css";

const Application: React.FC = () => {
  useEffect(() => {
    const zoom = (evt: Event) => {
      evt.preventDefault();
    };
    document.addEventListener("gesturestart", zoom);
    document.addEventListener("gesturechange", zoom);
    document.addEventListener("gestureend", zoom);

    return () => {
      document.removeEventListener("gesturestart", zoom);
      document.removeEventListener("gesturechange", zoom);
      document.removeEventListener("gestureend", zoom);
    };
  }, []);

  return (
    <AppProviders>
      <AppLayout />
    </AppProviders>
  );
};

export default Application;
